import { SectionContainer } from 'ui';
import { LayoutContainer } from 'layout';
import { mainContainer } from './organize-your-documents.module.scss';

import home from 'images/home.png';
import collectCards from 'images/collect-cards.png';
import { Module, ScreenshotAndText } from 'shared/components/screenshot-text/ScreenshotAndText';

export const OrganizeYourDocumentsSection = () => {
    return (
        <LayoutContainer>
            <SectionContainer>
                <div className={mainContainer}>
                    <ScreenshotAndText
                        title="A home for your documents"
                        text="Your source files need a home where they belong. Elumity’s unique library and toolset brings order to the chaos of your PDFs, images, and other files."
                        module={Module.LIBRARY}
                        image={home}
                        altText="documents"
                        reverse={true}
                    />
                    <ScreenshotAndText
                        title="Elumity Cards as your second brain"
                        text="Organize your knowledge as a net of connected information, adding new content contextual to your existing knowledge."
                        module={Module.CARDS}
                        image={collectCards}
                        altText="cards"
                    />
                </div>
            </SectionContainer>
        </LayoutContainer>
    );
};
